/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * EventIcon - Auto-generated from icon.js
 */
export const EventIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10 4H19V19H10V4ZM9 4H6L6 19H9V4ZM5 4C5 3.44772 5.44772 3 6 3H19C19.5523 3 20 3.44772 20 4V19C20 19.5523 19.5523 20 19 20H6C5.44772 20 5 19.5523 5 19V4ZM17 7.5C17 7.77614 16.7761 8 16.5 8H12.5C12.2239 8 12 7.77614 12 7.5C12 7.22386 12.2239 7 12.5 7H16.5C16.7761 7 17 7.22386 17 7.5ZM16.5 11C16.7761 11 17 10.7761 17 10.5C17 10.2239 16.7761 10 16.5 10H12.5C12.2239 10 12 10.2239 12 10.5C12 10.7761 12.2239 11 12.5 11H16.5Z"
			fill="current"
		/>
	</svg>
);

export default EventIcon;
